import { Outlet } from "react-router-dom";
import withAuthGuard from "@/hocs/withAuthGuard";

const Index = () => {
  return <Outlet />;
};

export default withAuthGuard(Index);
